// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cost-card-container {
  width: 240px;
  border-radius: 20px;
  background: var(--white);
  padding: 20px 20px 37px;
}
.cost-card-container h1 {
  font-weight: 400;
  font-size: 20px;
  line-height: 25.2px;
}
.cost-card-container span {
  font-weight: 800;
  font-size: 26px;
  line-height: 32.76px;
  color: var(--orange);
  margin-bottom: 15px;
}
.cost-card-container p {
  margin-top: 15px;
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/costCard/costCard.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".cost-card-container {\n  width: 240px;\n  border-radius: 20px;\n  background: var(--white);\n  padding: 20px 20px 37px;\n}\n.cost-card-container h1 {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 25.2px;\n}\n.cost-card-container span {\n  font-weight: 800;\n  font-size: 26px;\n  line-height: 32.76px;\n  color: var(--orange);\n  margin-bottom: 15px;\n}\n.cost-card-container p {\n  margin-top: 15px;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18.2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
